import React, { useEffect, useState } from 'react';
import {
  Table,
  Select,
  Icon,
  Popconfirm,
  Dropdown,
  Menu,
  Upload,
  message
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import deleteIcon from './delete.svg';
import userIcon from '../icons/user.svg';
import styled from 'styled-components';
import { StyleUsersCompany, StyledTableUsersCompany } from './style';
import { openNotification, headersSendForm } from '../../../../utils';
import { useSelector } from 'react-redux';
import { subContractService } from '../../../../services/subcontract.service';
import { projectService } from '../../../../services/project.service';
import ModalAddSubContract from '../../ModalAddSubContract';
import { ChromePicker } from 'react-color';
import ImgCrop from 'antd-img-crop';
import { base } from '../../../../services/base';
import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';

import useConfigurationPermissions from '../../../../hooks/useConfigurationPermissions';
function CardUsers({ t }) {
  const [ReloadTableUsers, setReloadTableUsers] = useState(true);

  const permissions = useConfigurationPermissions();
  const [onlyRead, setOnlyRead] = useState(permissions.project == 'V');
  const [search, setSearch] = useState('');
  const [copy, setCopy] = useState(null);
  const { Option } = Select;

  // GET ID COMPANY CURRENT FROM REDUX
  const stateCompany = useSelector((state) => state.companyState);
  const idCurrentCompany = stateCompany.currentCompany?.id;

  const [UserCompany, setUserCompany] = useState([]);
  const [showProjects, setshowProjects] = useState(false);

  // GET USERS BY COMPANY
  useEffect(() => {
    const getData = async () => {
      const response = await subContractService.getByCompany(idCurrentCompany);
      setUserCompany(response.subcontracts || []);
      setScColorsAll(response.subcontracts);
      setshowProjects(!showProjects);
    };
    getData();
  }, [ReloadTableUsers]);

  useEffect(() => {
    filter();
  }, [UserCompany, search]);

  // GET associated projects by user
  useEffect(() => {
    const abortController = new AbortController();
    const getProjectsByUsers = () => {
      const copyUsersCompany = [...UserCompany];
      UserCompany.map((user, index) => {
        projectService
          .ProjectsByUser(user.id)
          .then((response) => {
            copyUsersCompany[index] = {
              ...copyUsersCompany[index],
              projectsCount: response.projects.length
            };
            setUserCompany(copyUsersCompany);
          })
          .catch(() => console.log(t('settings.error_default')));
      });
    };
    getProjectsByUsers();
    return function cleanup() {
      abortController.abort();
    };
  }, [showProjects]);

  // Method for delete user of campany
  const deleteSub = (subcontract) => {
    subContractService
      .destroy(subcontract.id)
      .then((response) => {
        if (response) {
          const newUsers = UserCompany.filter(
            (user) => user.id !== subcontract.id
          );
          setUserCompany(newUsers);
          const alertSucces = {
            title: t('settings.organization_form.subcontracts.title'),
            description: t('settings.organization_form.subcontracts.deleted'),
            type: 'success'
          };
          trackingEvent(
            'company_deletion',
            {
              ...getBasicAmplitudEventProperties(),
              event_source: 'Company Settings',
              company_deleted_name: subcontract.name,
              company_deleted_id: subcontract.id
            },
            AMPLITUDE_SERVICE
          );
          openNotification(alertSucces);
        } else {
          const alertFail = {
            title: t('settings.organization_form.subcontracts.title'),
            description: t('settings.error_default'),
            type: 'error'
          };
          openNotification(alertFail);
        }
      })
      .catch(() => console.log(t('settings.error_default')));
  };

  const [Visible, setVisible] = useState(false);

  const openModalAddSubcontract = () => {
    setVisible(true);
  };

  const handleUserSettings = (index, name, value, userId) => {
    const copyUsers = [...UserCompany];
    const findIndex = copyUsers.findIndex((el) => el.id === userId);
    copyUsers[findIndex] = {
      ...copyUsers[findIndex],
      [name]: value
    };
    setUserCompany(copyUsers);
  };

  const updateTable = async (user) => {
    await subContractService
      .update(user)
      .then(() => {})
      .catch(() => {
        const alertError = {
          title: t('settings.organization_form.subcontracts.title'),
          description: t('settings.error_default'),
          type: 'error'
        };
        openNotification(alertError);
      });
  };

  const onChangeUpload = async (info, data) => {
    if (info.file.status === 'done') {
      data.image = info.file.response.name;
      await subContractService.update(data);
      let status;
      const hide = message.loading('Action in progress..', 0);
      while (status !== 200) {
        const response = await fetch(data.image);
        status = response.status;
      }
      setTimeout(hide, 100);
      setReloadTableUsers(!ReloadTableUsers);
    }
  };

  const columns = [
    {
      title: '',
      dataIndex: 'image',
      key: 'image',
      width: 60,
      render: (image, data) => (
        <ImgCrop rotate shape="rect" aspect={5 / 3} modalWidth={850}>
          <Upload
            action={`${base.api}subcontracts/upload`}
            listType="picture-card"
            showUploadList={false}
            headers={headersSendForm}
            onChange={(info) => onChangeUpload(info, data)}>
            <img
              src={image || userIcon}
              className="rounded-img-user"
              height="20px"
              width="20px"
            />
          </Upload>
        </ImgCrop>
      )
    },
    {
      title: t('settings.organization_form.subcontracts.name'),
      dataIndex: 'name',
      key: 'name',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => {
        a = a.name || '';
        b = b.name || '';
        return b.localeCompare(a);
      },
      render: (name, data, index) => (
        <input
          disabled={onlyRead}
          className="inp-table"
          placeholder={'-'}
          autoComplete="off"
          type="text"
          name="name"
          defaultValue={name}
          style={{ width: '90%', fontSize: '12px', border: '0px' }}
          onChange={(e) =>
            handleUserSettings(index, e.target.name, e.target.value, data.id)
          }
          title={name}
          onBlur={() => updateTable(data)}
        />
      )
    },
    {
      title: t('settings.organization_form.subcontracts.rut'),
      dataIndex: 'rut',
      key: 'rut',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => {
        a = a.rut || '';
        b = b.rut || '';
        return b.localeCompare(a);
      },
      render: (rut, data, index) => (
        <input
          disabled={onlyRead}
          className="inp-table"
          placeholder={'-'}
          autoComplete="off"
          type="text"
          name="rut"
          value={rut}
          style={{ width: '100%', fontSize: '12px', border: '0px' }}
          title={rut}
          onChange={(e) =>
            handleUserSettings(index, e.target.name, e.target.value, data.id)
          }
          onBlur={() => updateTable(data)}
        />
      )
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => {
        a = a.email || '';
        b = b.email || '';
        return b.localeCompare(a);
      },
      render: (email, data, index) => (
        <input
          disabled={onlyRead}
          className="inp-table"
          placeholder={'-'}
          autoComplete="off"
          type="text"
          name="email"
          defaultValue={email}
          style={{ width: '100%', fontSize: '12px', border: '0px' }}
          title={email}
          onChange={(e) =>
            handleUserSettings(index, e.target.name, e.target.value, data.id)
          }
          onBlur={() => updateTable(data)}
        />
      )
    },
    {
      title: t('settings.organization_form.subcontracts.type'),
      width: 100,
      dataIndex: 'type',
      key: 'type',
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => {
        a = a.type || '';
        b = b.type || '';
        return b.localeCompare(a);
      },
      render: (type, data, index) => (
        <input
          disabled={onlyRead}
          className="inp-table"
          placeholder={'-'}
          autoComplete="off"
          type="text"
          name="type"
          value={type}
          style={{ width: '100%', fontSize: '12px', border: '0px' }}
          title={type}
          onChange={(e) =>
            handleUserSettings(index, e.target.name, e.target.value, data.id)
          }
          onBlur={() => updateTable(data)}
        />
      )
    },
    {
      title: 'Color',
      width: 100,
      dataIndex: 'color',
      key: 'color',
      render: (color, data, index) => {
        index = state.findIndex((el) => el.id === data.id);
        return (
          <div>
            <div
              style={{
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
                position: 'relative',
                top: 2
              }}
              onClick={() => handleClick(index, data.id)}>
              <div
                style={{
                  width: '36px',
                  height: '14px',
                  borderRadius: '2px',
                  background: `${state[index] && state[index].hex}`
                }}
              />
            </div>
            {state[index] && state[index].displayColorPicker ? (
              <div
                style={{
                  position: 'absolute',
                  zIndex: '2'
                }}>
                <div
                  style={{
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px'
                  }}
                  onClick={() => handleClose(index, data.id)}
                />
                {onlyRead ? (
                  <div style={{ background: state[index].color }} />
                ) : (
                  <ChromePicker
                    className="picker-wrapp"
                    color={state[index].color}
                    onChange={(color) => handleChange(color, index, data.id)}
                  />
                )}
              </div>
            ) : null}
          </div>
        );
      }
    },
    {
      title: t('settings.organization_form.subcontracts.projects'),
      width: 150,
      dataIndex: 'projects',
      key: 'projects',
      render: (projects) => (
        <span className="no-image-span-no-center">
          <Dropdown
            overlay={
              <Menu>
                {projects.map((el, index) => (
                  <Menu.Item key={index}>{el.name}</Menu.Item>
                ))}
              </Menu>
            }
            trigger={['click']}>
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}>
              {projects.length === 0
                ? t('settings.project_subcontracts.no_projects')
                : projects.length > 1
                  ? projects.length +
                    ' ' +
                    t('settings.project_subcontracts.projects')
                  : projects.length +
                    ' ' +
                    t('settings.project_subcontracts.projects_single')}{' '}
              <DownOutlined />
            </a>
          </Dropdown>
        </span>
      )
    },
    {
      title: t('settings.organization_form.subcontracts.status'),
      dataIndex: 'status',
      key: 'status',
      render: (status, data, index) => (
        <button
          disabled={onlyRead}
          className={`btn-table-users ${
            status ? 'bg-btn-activo' : 'bg-btn-desactivo'
          }`}
          onClick={() => handleUserSettings(index, 'status', !status, data.id)}
          onBlur={() => updateTable(data)}>
          {status
            ? t('settings.project_subcontracts.active')
            : t('settings.project_subcontracts.inactive')}
        </button>
      )
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      render: (dataObject) => {
        if (onlyRead) {
          return null;
        }
        return (
          <Popconfirm
            onConfirm={() => deleteSub(dataObject)}
            title={t('settings.organization_form.subcontracts.are_you_sure')}
            icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}>
            <img src={deleteIcon} alt="delete" style={{ cursor: 'pointer' }} />
          </Popconfirm>
        );
      }
    }
  ];

  const templateColors = {
    displayColorPicker: false,
    color: {
      r: '241',
      g: '112',
      b: '19',
      a: '1'
    }
  };

  const [state, setState] = useState([]);
  const [scColorsAll, setScColorsAll] = useState([]);
  const [idEdit, setIdEdit] = useState(false);

  useEffect(() => {
    const arrTmp = [];
    if (scColorsAll?.length) {
      scColorsAll.map((el) => {
        arrTmp.push({
          ...templateColors,
          hex: el.color,
          id: el.id
        });
      });
      setState(arrTmp);
    }
  }, [scColorsAll]);

  const handleClick = (index, userId) => {
    const copyState = [...state];
    const findIndex = copyState.findIndex((el) => el.id === userId);
    copyState[findIndex] = {
      ...copyState[findIndex],
      displayColorPicker: !copyState[findIndex].displayColorPicker
    };
    setState(copyState);
  };

  const handleClose = (index, userId) => {
    const copyState = [...state];
    const findIndex = copyState.findIndex((el) => el.id === userId);
    copyState[findIndex] = {
      ...copyState[findIndex],
      displayColorPicker: false
    };
    setState(copyState);
    handleCatsSettings(findIndex, 'color', state[findIndex].hex);
  };

  const handleChange = (color, index, userId) => {
    const copyState = [...state];
    const findIndex = copyState.findIndex((el) => el.id === userId);
    copyState[findIndex] = {
      ...copyState[findIndex],
      color: color.rgb,
      hex: color.hex
    };
    setState(copyState);
  };

  const handleCatsSettings = (index, name, value) => {
    const copyCats = [...scColorsAll];
    copyCats[index] = {
      ...copyCats[index],
      [name]: value
    };
    setScColorsAll(copyCats);
    setIdEdit(index);
  };

  useEffect(() => {
    if (idEdit !== false) {
      updateSubcontract(scColorsAll[idEdit]);
    }
  }, [idEdit]);

  const updateSubcontract = async (data) => {
    await subContractService.update(data);
    setIdEdit(false);
  };

  const filter = () => {
    if (!search) {
      setCopy(UserCompany);
      return;
    }
    const filteredData = UserCompany.filter(
      (entry) =>
        (entry.name &&
          entry.name.toLowerCase().includes(search.toLowerCase())) ||
        (entry.rut && entry.rut.toLowerCase().includes(search.toLowerCase())) ||
        (entry.email &&
          entry.email.toLowerCase().includes(search.toLowerCase())) ||
        (entry.type && entry.type.toLowerCase().includes(search.toLowerCase()))
    );
    setCopy(filteredData);
  };

  const handleChangeSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  return (
    <StyleUsersCompany>
      <div>
        <div className="grid-options-users">
          <div></div>
          <div style={{ display: 'inline-flex', justifyContent: 'center' }}>
            <button
              disabled={onlyRead}
              className="btn-table-add bg-btn-add"
              onClick={() => openModalAddSubcontract()}>
              <Icon type="plus" style={{ marginRight: '5px' }} />
              <b style={{ fontSize: '12px' }}>
                {t('settings.organization_form.subcontracts.add')}
              </b>
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', margin: 2 }}>
          <input
            className="inp-table"
            placeholder={t('settings.project_subcontracts.search') + ' ...'}
            autoComplete="off"
            type="text"
            name="search"
            value={search || ''}
            style={{
              width: '180px',
              fontSize: '14px',
              border: '1px solid',
              borderColor: '#2C3421',
              margin: 2,
              paddingLeft: 10
            }}
            onChange={handleChangeSearch}
          />
        </div>
        <StyledTableUsersCompany>
          <Table
            className="user-settings-company"
            columns={columns}
            dataSource={copy}
            pagination={{ pageSize: 15 }}
            rowKey={(obj) => obj.id}
          />
        </StyledTableUsersCompany>
        <ModalAddSubContract
          t={t}
          modCompany={true}
          Visible={Visible}
          setVisible={setVisible}
          setReloadTableUsers={setReloadTableUsers}
          ReloadTableUsers={ReloadTableUsers}
        />
      </div>

      <div></div>
    </StyleUsersCompany>
  );
}

export default CardUsers;

const SelectionCargoStyle = styled.div`
  .ant-select-selection {
    border-radius: 5px !important;
  }
  .ant-select-selection {
    background-color: white !important;
    color: #121212;
  }
  .anticon svg {
    color: transparent;
  }

  .ant-select-selection,
  ant-select-selection--single {
    border-right: 0px;
    border-left: 0px;
    border-bottom: 0px;
    border-top: 0px;
  }

  .ant-select-selection:focus,
  ant-select-selection--single:focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
`;
